import { Navigate } from 'react-router-dom'
import { Loader, Stack } from '@mantine/core'
import { useAppUser } from '../api/account'

export default function AppRedirect() {
  const { data: user, isPending } = useAppUser()

  if (isPending) {
    return (
      <Stack align="center" justify="center" h="100vh">
        <Loader />
      </Stack>
    )
  }

  if (user) {
    return <Navigate to="/app/profile" replace />
  }

  return <Navigate to="/app/login" replace />
}
